import React from 'react'
import {createColumnHelper, IdentifiedColumnDef} from '@tanstack/react-table'
import {EmptyColumnDefType} from 'commonTypes'
import RequestIdCell from './cell/RequestId'
import JobRequestCategoryCell from './cell/JobRequestCategory'
import TotalCell from './cell/Total'

// @ts-ignore
import {DataGridColumns} from '@mdsol/onex-design'
import {JobRequest} from 'graphql-api'
import DatabaseName from 'components/view/jobRequests/jobRequestsHistory/cell/DatabaseName'

export type JobRequestColumnDefType = JobRequest | EmptyColumnDefType

const columnHelper = createColumnHelper<JobRequestColumnDefType>()

const columnsConfig: DataGridColumns[] = [
  columnHelper.accessor(
    'requestId',
    {
      header: 'Request Id',
      textAlign: 'left',
      className: 'job-status-request-grid-cell job-status-request-id-cell',
      cell: props => <RequestIdCell {...props} />,
    } as IdentifiedColumnDef<JobRequestColumnDefType, any>
  ),
  columnHelper.accessor(
    'category',
    {
      accessorFn: (row) => row.categoryName || '',
      header: 'Category',
      textAlign: 'left',
      className: 'job-status-request-grid-cell',
      enableSorting: false,
      cell: props => <JobRequestCategoryCell {...props} />,
    } as IdentifiedColumnDef<JobRequestColumnDefType, any>
  ),
  columnHelper.accessor(
    'databaseId',
    {
      accessorFn: (row) => row.databaseId || '',
      header: 'URL',
      textAlign: 'left',
      className: 'job-status-request-grid-cell',
      defaultFilter: true,
      cell: props => <DatabaseName {...props} />,
    } as IdentifiedColumnDef<JobRequestColumnDefType, any>
  ),
  columnHelper.accessor(
    'studyName',
    {
      accessorFn: (row) => row.studyName || '',
      header: 'Study',
      textAlign: 'left',
      className: 'job-status-request-grid-cell',
      enableSorting: false,
    } as IdentifiedColumnDef<JobRequestColumnDefType, any>
  ),
  columnHelper.accessor(
    'changesAfterDate',
    {
      accessorFn: (row) => row.changesAfterDate || '',
      header: 'Changes after',
      textAlign: 'left',
      className: 'job-status-request-grid-cell',
    } as IdentifiedColumnDef<JobRequestColumnDefType, any>
  ),
  columnHelper.accessor(
    'jobCount',
    {
      header: 'Jobs Created',
      className: 'job-status-request-grid-cell',
      cell: props => <TotalCell {...props} />,
    } as IdentifiedColumnDef<JobRequestColumnDefType, any>
  ),
  columnHelper.accessor(
    'created',
    {
      header: 'Time Created',
      textAlign: 'left',
      className: 'job-status-request-grid-cell',
    } as IdentifiedColumnDef<JobRequestColumnDefType, any>
  ),
  columnHelper.accessor(
    'username',
    {
      accessorFn: (row) => row.username || '',
      header: 'Created By',
      textAlign: 'left',
      className: 'job-status-request-grid-cell',
    } as IdentifiedColumnDef<JobRequestColumnDefType, any>
  ),
]

export default columnsConfig
